module.exports = __webpack_public_path__ + "img/PL08453.0e38cf2b.svg";